import { graphql } from '~/graphql/generated/gql';

export const fetchLearningAssets = graphql(`
  query fetchLearningAssets($first: Int, $page: Int, $filters: LearningAssetFilters, $orderBy: [LearningAssetOrder!]) {
    learningAssets(first: $first, page: $page, filters: $filters, orderBy: $orderBy) {
      data {
        id
        name
        subtitle
        templateName
        type
        duration
        slug
        order
        publishedAt
        publishedContentId
        coinValue {
          ...CoinValueFields
        }
        completionCount
        coverImage {
          id
          publicUrl
          title
        }
        meta {
          title
        }
        currentUserProgress {
          id
          completedAt
        }
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);
export const fetchLearningAsset = graphql(`
  query fetchLearningAsset($filters: LearningAssetFilters) {
    learningAssets(first: 1, filters: $filters) {
      data {
        id
        name
        templateName
        type
        duration
        slug
        order
        publishedAt
        publishedContentId
        coverImage {
          ...PublicFileFields
        }
        coinValue {
          ...CoinValueFields
        }
        partnerId
        partner {
          id
          name
        }
        spotlight {
          ...SpotlightFields
        }
        publishedContent {
          ...LearningContentFields
        }
        currentUserProgress {
          ...UserProgressFields
        }
        meta {
          ...SeoMetaFields
        }
        learningOutcomes
        structuredLearningOutcome {
          title
          description
        }
        publishedSkills {
          ...SkillFields
        }
        indexingMetadata {
          careerCluster
          jobsList {
            id
            title
          }
          skillsList
          riasecSkills
        }
        considerationAreas {
          id
          label
        }
        # The questionnaire the coach offers once this activity is finished. Selected with the
        # same fragment the collection's uses: the definition has no id of its own, so graphcache
        # stores it as a keyless object on the asset and two shapes would fight over that field.
        feedbackSurvey {
          ...FeedbackSurveyDefinitionFields
        }
        # Viewer-scoped, so the survey screen can show the thanks-and-coins overlay for an
        # externally-answered survey on a reload; null everywhere else.
        externalFeedbackSurveyCoinsAwarded
      }
    }
  }
`);

export const fetchAdminLearningAssets = graphql(`
  query fetchAdminLearningAssets($first: Int, $page: Int, $filters: AdminLearningAssetFilters, $orderBy: [AdminLearningAssetOrder!]) {
    learningAssetsList(first: $first, page: $page, filters: $filters, orderBy: $orderBy) {
      data {
        id
        name
        subtitle
        internalName
        templateName
        type
        duration
        slug
        order
        publishedAt
        publishedContentId
        draftContentId
        createdAt
        updatedAt
        coinValue {
          ...CoinValueFields
        }
        completionCount
        coverImage {
          id
          publicUrl
          title
        }
        meta {
          title
        }
        curriculumTags {
          ...AdminCurriculumTagFields
        }
        considerationAreas {
          id
          label
        }
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const fetchAdminLearningAssetsList = graphql(`
  query fetchAdminLearningAssetsList($first: Int, $page: Int, $filters: AdminLearningAssetFilters, $orderBy: [AdminLearningAssetOrder!]) {
    learningAssetsList(first: $first, page: $page, filters: $filters, orderBy: $orderBy) {
      data {
        id
        name
        internalName
        templateName
        type
        duration
        publishedAt
        publishedContentId
        draftContentId
        createdAt
        coinValue {
          coins
        }
        completionCount
        considerationAreas {
          id
          label
        }
        curriculumTags {
          ...AdminCurriculumTagFields
        }
        # Only what the health column scores: a story row's story data, not the whole block tree.
        draftContent {
          data {
            learningAssetContentItems {
              ... on StoryAssetItem {
                storyData
              }
            }
          }
        }
      }
      paginatorInfo {
        ...PaginatorInfoFields
      }
    }
  }
`);

export const fetchAdminLearningAsset = graphql(`
  query fetchAdminLearningAsset($filters: AdminLearningAssetFilters) {
    learningAssetsList(first: 1, filters: $filters) {
      data {
        id
        name
        internalName
        templateName
        type
        duration
        slug
        order
        publishedAt
        publishedContentId
        draftContentId
        createdAt
        updatedAt
        coverImage {
          ...AdminContentFileFields
        }
        partnerId
        partner {
          id
          name
        }
        coinValue {
          ...CoinValueFields
        }
        spotlight {
          ...AdminSpotlightFields
        }
        publishedContent {
          ...AdminLearningContentFields
        }
        draftContent {
          ...AdminLearningContentFields
          skills {
            ...AdminSkillFields
          }
        }
        meta {
          ...SeoMetaFields
        }
        learningOutcomes
        structuredLearningOutcome {
          title
          description
        }
        publishedSkills {
          ...AdminSkillFields
        }
        indexingMetadata {
          careerCluster
          jobsList {
            id
            title
          }
          skillsList
          riasecSkills
        }
        considerationAreas {
          id
          label
        }
        curriculumTags {
          ...AdminCurriculumTagFields
        }
      }
    }
  }
`);
